import { NotificationsApi } from 'conversations/api'
import { captureError } from 'conversations/utils/logRocket'
import { DesktopNotificationPayloadBase } from 'shared/src/notifications/DesktopPushNotification'

const auditLogEventType = Object.freeze({
  WEBPUSH_NOTIFICATION_RECEIVE: 'WEBPUSH_NOTIFICATION_RECEIVE',
})

const buildAuditLogSortKey = (notification: DesktopNotificationPayloadBase) => {
  return `${notification.notificationType}|${notification.timestamp}|${notification.notificationId}`
}

const buildAuditLogTrackingPayload = (notification: DesktopNotificationPayloadBase) => {
  return {
    driftUserId: notification.userId,
    auditLogSortKey: buildAuditLogSortKey(notification),
    eventType: auditLogEventType.WEBPUSH_NOTIFICATION_RECEIVE,
    timestamp: Date.now().toString(),
    permissionGranted: true,
  }
}

export const updateNotificationsAuditLog = async (notification: DesktopNotificationPayloadBase) => {
  try {
    await NotificationsApi.post(
      '/audit_log/websocket_event',
      buildAuditLogTrackingPayload(notification)
    )
  } catch (error) {
    captureError(error, 'Post notifications to audit log failed')
    return notification
  }
}
